import { favoritesSchema } from "@/schemas/favorites-schema";
import { useState } from "@wordpress/element";

const STORAGE_KEY = "favorites";

export interface IFav {
	id: string;
	nameEn: string;
	nameAr: string;
}

export const useFavorites = () => {
	const [favorites, setFavorites] = useState<IFav[]>(() => {
		if (typeof window === "undefined") return [];

		try {
			const stored = localStorage.getItem(STORAGE_KEY);
			if (!stored) return [];

			const parsed = JSON.parse(stored);

			return Array.isArray(parsed)
				? parsed.flatMap((item) => {
						const result = favoritesSchema.safeParse(item);
						return result.success ? [result.data] : [];
				  })
				: [];
		} catch {
			return [];
		}
	});

	const isFavorite = (id: string): boolean => {
		return !!favorites.find((item) => item.id === id);
	};

	const handleToggleFavorites = ({ id, nameEn, nameAr }: IFav): void => {
		const itemFormatted = {
			id,
			nameEn,
			nameAr,
		};

		const findItem = favorites.find((item) => item.id === id);

		if (findItem) {
			const newArray = favorites.filter((item) => item.id !== id);
			setFavorites(() => {
				return newArray;
			});

			localStorage.setItem(STORAGE_KEY, JSON.stringify(newArray));
		} else {
			const newArray = [...favorites, itemFormatted];
			setFavorites(() => {
				return newArray;
			});

			localStorage.setItem(STORAGE_KEY, JSON.stringify(newArray));
		}
	};

	return {
		favorites,
		handleToggleFavorites,
		isFavorite,
	};
};
